/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElTabs as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/tabs/style/css';
import { ElTabPane as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/tab-pane/style/css';
import { ElButton as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElRadioGroup as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadio as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/radio/style/css';
import { ElSelect as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4a7e89f0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "padding-left": "20px"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "渠道包信息：", -1));
const _hoisted_3 = {
  class: "pkg-info"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "r-wrapper"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_10 = {
  class: "t-right"
};
import { apiUsdkCpsChannelPackage, apiUsdkCpsRepack } from '@/api/usdk';
import { useAppStore } from '@/store/modules/app';
import PlugConfig from '@/views/pack/channel/modules/plugConfig.vue';
import { UseGetGameChannel } from '@/utils/hooks';
import ProjectLogin from '@/views/operate/officialPackage/officialSubPackage/projectLogin.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'subPackageConf',
  emits: ['success'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const dialogVisible = ref(false);
    const gameInfo = computed(() => useAppStore().gameInfo);
    const item = ref();
    const list = ref([]);
    const pluginsRef = ref();
    const confirmLoading = ref(false);
    const pkgFrom = ref({
      ProjectId: '',
      IsAutoCdn: 0,
      PackageId: ''
    });
    const pluginRadio = ref(1);
    const getGameChannel = UseGetGameChannel();
    const currentItem = computed(() => {
      if (!pkgFrom.value.PackageId) return {};
      return list.value.filter(item => item.id === pkgFrom.value.PackageId)[0];
    });
    const currentTab = ref('1');
    const onShow = data => {
      dialogVisible.value = true;
      item.value = data;
      pluginRadio.value = data.isPluginCustom ? 2 : 1;
      getList();
      getChannel();
      currentTab.value = '1';
      console.log(data);
    };
    const getList = async () => {
      let params = {
        gid: gameInfo.value.Id,
        cid: item.value.cid
      };
      let res = await apiUsdkCpsChannelPackage(params);
      if (res.code != 0) return;
      list.value = res.data;
      pkgFrom.value.PackageId = list.value[0].id || '';
    };
    const getChannel = () => {
      getGameChannel({
        gid: gameInfo.value.Id,
        isHero: 1,
        needIos: 0
      }).then(data => {
        console.log({
          data
        });
      });
    };
    // usdk cps pack
    const handleSubPackage = () => {
      let plugins = [];
      if (pluginRadio.value === 2) {
        const {
          plugs,
          plusItemList
        } = pluginsRef.value.createParams();
        try {
          plugs.forEach(pid => {
            let obj = {
              plugId: pid,
              plugPara: []
            };
            plusItemList.forEach(p => {
              if (p.pid === pid) {
                obj.plugPara.push({
                  key: p.ptkey,
                  value: p.value
                });
              }
            });
            plugins.push(obj);
          });
        } catch (error) {}
      }
      confirmLoading.value = true;
      console.log({
        plugins
      });
      apiUsdkCpsRepack({
        plugins: plugins,
        // productId: currentData.ProductId,
        // projectId: currentData.projectId,
        // serverId: currentData.ServerId,
        plcId: item.value.id,
        plId: currentItem.value.id,
        // packageId: this.packageFormModel.PackageId,
        isPluginCustom: pluginRadio.value === 2
      }).then(res => {
        if (res.code === 0) {
          emits('success');
        }
      }).finally(() => {
        confirmLoading.value = false;
      });
    };
    expose({
      onShow
    });
    return (_ctx, _cache) => {
      const _component_el_option = __unplugin_components_0;
      const _component_el_select = __unplugin_components_1;
      const _component_el_radio = __unplugin_components_2;
      const _component_el_radio_group = __unplugin_components_3;
      const _component_el_button = __unplugin_components_4;
      const _component_el_tab_pane = __unplugin_components_5;
      const _component_el_tabs = __unplugin_components_6;
      const _component_el_dialog = __unplugin_components_7;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: "更多",
        width: "700px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tabs, {
          modelValue: _unref(currentTab),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(currentTab) ? currentTab.value = $event : null),
          "tab-position": "left",
          type: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            label: "分包配置",
            name: "1"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_hoisted_2, _createVNode(_component_el_select, {
              modelValue: _unref(pkgFrom).PackageId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(pkgFrom).PackageId = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.title,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
              src: _unref(currentItem).icon,
              alt: ""
            }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createTextVNode(" 游戏名：" + _toDisplayString(_unref(currentItem).gameTitle), 1), _hoisted_6, _createTextVNode(" 包名：" + _toDisplayString(_unref(currentItem).packageName), 1), _hoisted_7, _createTextVNode(" 游戏版本：V" + _toDisplayString(_unref(currentItem).verName), 1), _createElementVNode("span", null, "（Code:" + _toDisplayString(_unref(currentItem).verCode) + "）", 1), _hoisted_8, _createTextVNode(" 包体大小：" + _toDisplayString((_unref(currentItem).fileSize / 1024 / 1024).toFixed(2)) + "M", 1), _hoisted_9])]), _createVNode(_component_el_radio_group, {
              modelValue: _unref(pluginRadio),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(pluginRadio) ? pluginRadio.value = $event : null)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_createTextVNode("使用分包来源(" + _toDisplayString(_unref(item).originChannel) + ")的插件配置", 1)]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 2
              }, {
                default: _withCtx(() => [_createTextVNode("自定义插件配置")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"]), _unref(pluginRadio) === 2 ? (_openBlock(), _createBlock(PlugConfig, {
              key: 0,
              ref_key: "pluginsRef",
              ref: pluginsRef,
              "active-name": "pluginConf",
              channel: {
                cid: _unref(item).cid
              },
              cpsId: _unref(item).id,
              gid: _unref(gameInfo).Id,
              isCps: ""
            }, null, 8, ["channel", "cpsId", "gid"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
              disabled: _unref(item).cdnStatus === 5 && !!_unref(item).cdnTime,
              loading: _unref(confirmLoading),
              type: "primary",
              onClick: handleSubPackage
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(item).cdnStatus === 5 && _unref(item).cdnTime ? '定时发布状态无法重新打包' : '保存，并重新打包'), 1)]),
              _: 1
            }, 8, ["disabled", "loading"])])])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "登录管理",
            name: "2"
          }, {
            default: _withCtx(() => [_unref(currentTab) === "2" ? (_openBlock(), _createBlock(ProjectLogin, {
              key: 0,
              item: _unref(item)
            }, null, 8, ["item"])) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});